package com.iregained.site.components.sections.patients.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val FinalCtaButtonStyle = CssStyle {
    base {
        Modifier
            .transition(Transition.of("transform", 300.ms), Transition.of("box-shadow", 300.ms))
    }
    hover {
        Modifier
            .translateY((-2).px)
            .boxShadow(0.px, 4.px, 15.px, color = org.jetbrains.compose.web.css.rgba(0, 0, 0, 0.2f))
    }
}